function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref2 =
/*#__PURE__*/
/*#__PURE__*/
React.createElement("g", {
  clipPath: "url(#clip0_1168_1867)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8 17L12 21L16 17",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12 12V21",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.8802 18.09C21.7496 17.4786 22.4015 16.6062 22.7415 15.5991C23.0814 14.5921 23.0916 13.503 22.7706 12.4898C22.4496 11.4766 21.814 10.5921 20.9562 9.96456C20.0985 9.33703 19.063 8.99917 18.0002 9H16.7402C16.4394 7.82787 15.8767 6.73925 15.0943 5.81608C14.3119 4.89291 13.3303 4.15926 12.2234 3.67036C11.1164 3.18145 9.91302 2.95003 8.7037 2.99352C7.49439 3.03701 6.31069 3.35427 5.24173 3.92143C4.17277 4.48858 3.2464 5.29085 2.53236 6.26783C1.81833 7.24481 1.33523 8.37105 1.11944 9.56175C0.903647 10.7525 0.960787 11.9766 1.28656 13.142C1.61233 14.3074 2.19824 15.3838 3.00018 16.29",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));
var _ref3 =
/*#__PURE__*/
/*#__PURE__*/
React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_1168_1867"
}, /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  fill: "white"
})));
const SvgDownload = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), _ref2, _ref3);
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDownload, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/download.ed924908.svg";
export { ForwardRef as ReactComponent };